import AddAnnotationTransform from './add_annotation';
import RemoveAnnotationTransform from './remove_annotation';
import SetAnnotationTransform from './set_annotation';
import AddMetadataTransform from './add_metadata';
import RemoveMetadataTransform from './remove_metadata';
import SetMetadataTransform from './set_metadata';

export default {
  AddAnnotation: AddAnnotationTransform,
  RemoveAnnotation: RemoveAnnotationTransform,
  SetAnnotation: SetAnnotationTransform,
  AddMetadata: AddMetadataTransform,
  RemoveMetadata: RemoveMetadataTransform,
  SetMetadata: SetMetadataTransform,
};
